(function() {

  'use strict';

  function enderecoJS($filter) {
    return function(endereco, quebrarEmDuasLinhas) {
      if (endereco && endereco.cep) {
        try {
          var enderecoFormatado = endereco.logradouro.trim() + ', ' +
            endereco.numero.trim() + ', ' +
            (endereco.complemento ? endereco.complemento.trim() + ', ' : '') +
            (quebrarEmDuasLinhas ? '<br />' : '') +
            endereco.bairro + ', ' +
            $filter('cep')(endereco.cep) + ', ' +
            endereco.cidade + ' - ' +
            (endereco.uf ? endereco.uf : endereco.estado)
          return enderecoFormatado;

        } catch (e) {}
      }
    };

  };

  angular.module('mandaeApp')
    .filter('enderecoJS', enderecoJS);
})();
